import { DtoApiPager } from "./abst/DtoApiPager";
import { DtoSponsorsGetRes } from "./abst/DtoSponsorsGetRes";

export class DtoSponsorsGetResImple extends DtoSponsorsGetRes {
  public pager = new DtoApiPager();
}
